import { render, staticRenderFns } from "./gz.vue?vue&type=template&id=7519f84b&scoped=true"
import script from "./gz.vue?vue&type=script&lang=js"
export * from "./gz.vue?vue&type=script&lang=js"
import style0 from "./gz.vue?vue&type=style&index=0&id=7519f84b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519f84b",
  null
  
)

export default component.exports